"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialSubscriptionCancel = exports.CommercialSubscriptionUpdate = exports.CommercialSubscriptionCreate = exports.CommercialSubscriptionQuery = exports.CommercialSubscriptionTransport = exports.CommercialSubscription = exports.CommercialSubscriptionTimeRestriction = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const collection_relation_update_1 = require("../../common/collection-relation-update");
const BillingDetails_1 = require("./BillingDetails");
const CommercialContract_1 = require("./CommercialContract");
const ServicePeriod_1 = require("./ServicePeriod");
const SubscriptionEquipment_1 = require("./SubscriptionEquipment");
const commercial_subscription_shared_1 = require("./commercial-subscription-shared");
exports.CommercialSubscriptionTimeRestriction = typebox_1.Type.Object({
    onlyAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'time' })), // If set, the location should not be serviced before this time
    onlyBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'time' })), // If set, the location should not be serviced after this time
});
exports.CommercialSubscription = typebox_1.Type.Intersect([
    commercial_subscription_shared_1.CommercialSubscriptionSharedFields,
    typebox_1.Type.Object({
        equipment: typebox_1.Type.Array(SubscriptionEquipment_1.SubscriptionEquipmentTransport),
        billingDetails: BillingDetails_1.BillingDetails,
        servicePeriods: typebox_1.Type.Array(ServicePeriod_1.ServicePeriod),
        contracts: typebox_1.Type.Array(CommercialContract_1.CommercialContractTransport),
    }),
]);
exports.CommercialSubscriptionTransport = exports.CommercialSubscription;
exports.CommercialSubscriptionQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([common_1.BaseQuery, commercial_subscription_shared_1.CommercialSubscriptionSharedQuery]));
exports.CommercialSubscriptionCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(commercial_subscription_shared_1.CommercialSubscriptionSharedCreateFields, [
        'id',
        'haulerID',
        'equipment',
        'billingDetails',
        'servicePeriods',
        'status',
        'contracts',
        'contract',
        'metadata',
    ]),
    typebox_1.Type.Object({
        equipment: typebox_1.Type.Array(SubscriptionEquipment_1.SubscriptionEquipmentCreate),
        billingDetails: BillingDetails_1.BillingDetailsCreate,
        servicePeriods: typebox_1.Type.Optional(typebox_1.Type.Array(ServicePeriod_1.ServicePeriodCreate)),
        contract: typebox_1.Type.Optional(CommercialContract_1.CommercialContractCreate),
        paymentDetails: typebox_1.Type.Optional(commercial_subscription_shared_1.CommercialPaymentDetails),
    }),
]);
exports.CommercialSubscriptionUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(commercial_subscription_shared_1.CommercialSubscriptionSharedUpdateFields, ['equipment', 'billingDetails', 'servicePeriods', 'contracts']),
    typebox_1.Type.Object({
        equipment: typebox_1.Type.Optional((0, collection_relation_update_1.CollectionRelationUpdate)(SubscriptionEquipment_1.SubscriptionEquipmentCreate, SubscriptionEquipment_1.SubscriptionEquipmentUpdate, typebox_1.Type.String({ format: 'uuid' }))),
        contracts: typebox_1.Type.Optional((0, collection_relation_update_1.CollectionRelationUpdate)(CommercialContract_1.CommercialContractCreate, CommercialContract_1.CommercialContractUpdate, typebox_1.Type.String({ format: 'uuid' }))),
        billingDetails: BillingDetails_1.BillingDetailsUpdate,
        servicePeriods: typebox_1.Type.Optional((0, collection_relation_update_1.CollectionRelationUpdate)(ServicePeriod_1.ServicePeriodCreate, ServicePeriod_1.ServicePeriod, typebox_1.Type.String({ format: 'uuid' }))),
        subscriptionNumber: (0, common_1.Nullable)(typebox_1.Type.String()),
        timeRestriction: typebox_1.Type.Object({
            onlyAfter: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'time' }))),
            onlyBefore: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'time' }))),
        }),
        poNumber: (0, common_1.Nullable)(typebox_1.Type.String()),
        notes: (0, common_1.Nullable)(typebox_1.Type.String()),
        gateCode: (0, common_1.Nullable)(typebox_1.Type.String()),
        cancellationReason: typebox_1.Type.String(),
    }),
]));
exports.CommercialSubscriptionCancel = typebox_1.Type.Object({
    cancellationReason: typebox_1.Type.Optional(typebox_1.Type.String()),
    cancelDate: typebox_1.Type.String({ format: 'date' }),
});
//# sourceMappingURL=CommercialSubscription.js.map